/**
 * App package registry
 *
 * Every decomposed app contributes its chrome here — topbar titles, breadcrumb
 * labels, sidebar entry — so adding one stops meaning "edit DashboardLayout and
 * Breadcrumbs". The router mounts each app separately behind its own dynamic
 * import; this file is only the chrome half.
 *
 * appManifests is derived from the generated appRegistry (registry.gen.ts)
 * rather than hand-listed here — hand-listing put every app extraction on a
 * collision course with every other one, with two engineers adding a package
 * in the same week both editing this exact array for entries neither of them
 * needed to think about.
 *
 * The manifest is data only; the barrel reaches components, and pulling those
 * in here would put the app back in the initial bundle. appRegistry already
 * honors that (its manifest imports go through each app's `/manifest`
 * subpath, never its barrel) — nothing below needs to re-enforce it, just not
 * undo it.
 */ import { appRegistry } from './registry.gen';
export const appManifests = appRegistry.map((app)=>app.manifest);
/** Topbar title/description patterns owned by app packages. */ export const appPageMetadata = appManifests.flatMap((app)=>app.meta ?? []);
/** Static path segment -> breadcrumb label, merged across apps. */ export const appCrumbs = {};
for (const app of appManifests){
    for (const [segment, label] of Object.entries(app.crumbs ?? {})){
        appCrumbs[segment] = label;
    }
}
